import React from 'react'
import './Footer.css'

export const Footer = ({ cssClass  }) => {
  return (
    <footer className={`wordpay-demo__footer ${cssClass ? cssClass : ''}`}>
        <h3 className='wordpay-demo__footer-text'>Wordpay DemoPage 2022</h3>
    </footer>
  )
}
